import { render } from "./page16.vue?vue&type=template&id=56a84dac&scoped=true"
import script from "./page16.vue?vue&type=script&lang=js"
export * from "./page16.vue?vue&type=script&lang=js"

import "./page16.vue?vue&type=style&index=0&id=56a84dac&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a84dac"]])

export default __exports__